import { CompanystatisticModel } from './../models/LicensesModel'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import LicencesService from '../LicensesService'
import {
  CustomerModel,
  FiltersCollectionModel,
  LicensesModel,
  NewLicenseModel,
  SerialNumberRequestModel,
  SyncCompanyListModel,
  SyncExternalServiceModel,
  SyncLicenseModel,
  SyncResellersModel,
} from '../models/LicensesModel'
import { DateFilterModel } from '@/core/interfaces/data-filter'

export interface LicencesState {
  licenses: LicensesModel | null
  companystatistic: CompanystatisticModel[]
}

const initialState: LicencesState = {
  licenses: null,
  companystatistic: [],
}

export const getLicencesThunk = createAsyncThunk(
  'licences/getLicencesThunk',
  async (data: FiltersCollectionModel, { rejectWithValue }) => {
    try {
      return await LicencesService.getLicenses(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const updateLicenseThunk = createAsyncThunk(
  'licences/updateLicenseThunk',
  async (data: CustomerModel & { id: string }, { rejectWithValue }) => {
    try {
      return await LicencesService.updateLicense(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getCompanystatisticThunk = createAsyncThunk(
  'licences/getCompanystatisticThunk',
  async (filter: DateFilterModel, { rejectWithValue }) => {
    try {
      return await LicencesService.getCompanystatistic(filter)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const licensesByCompanyCodeThunk = createAsyncThunk(
  'licenses/licensesByCompanyCodeThunk',
  async (companyCode: string, { rejectWithValue }) => {
    try {
      return await LicencesService.licensesByCompanyCode(companyCode)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const licensesReassignResellerThunk = createAsyncThunk(
  'licenses/licensesReassignReseller',
  async (licenseId: string, { rejectWithValue }) => {
    try {
      return await LicencesService.licensesReassignReseller(licenseId)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const licensesSerialNumberThunk = createAsyncThunk(
  'licenses/licensesSerialNumberThunk',
  async (data: SerialNumberRequestModel, { rejectWithValue }) => {
    try {
      return await LicencesService.licensesSerialNumber(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const licensesTrialByDeviceSerialThunk = createAsyncThunk(
  'licenses/licensesTrialByDeviceSerialThunk',
  async (data: NewLicenseModel, { rejectWithValue }) => {
    try {
      return await LicencesService.licensesTrialByDeviceSerial(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const syncLicenseThunk = createAsyncThunk(
  'licenses/syncmanagerThunk',
  async (data: SyncLicenseModel, { rejectWithValue }) => {
    try {
      return await LicencesService.syncLicense(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const syncResellersThunk = createAsyncThunk(
  'licenses/syncresellersThunk',
  async (data: SyncResellersModel, { rejectWithValue }) => {
    try {
      return await LicencesService.syncResellers(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const syncExternalServiceThunk = createAsyncThunk(
  'licenses/syncexternalserviceThunk',
  async (data: SyncExternalServiceModel, { rejectWithValue }) => {
    try {
      return await LicencesService.syncExternalService(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const syncCompanyListThunk = createAsyncThunk(
  'licenses/synccompanylistThunk',
  async (data: SyncCompanyListModel, { rejectWithValue }) => {
    try {
      return await LicencesService.syncCompanyList(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const licensesFreeByDiscountCodeThunk = createAsyncThunk(
  'licenses/licensesFreeByDiscountCodeThunk',
  async (data: NewLicenseModel, { rejectWithValue }) => {
    try {
      return await LicencesService.licensesFreeByDiscountCode(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const authSlice = createSlice({
  name: 'licences',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getLicencesThunk.fulfilled, (state, action) => {
        state.licenses = action.payload
      })

      .addCase(getLicencesThunk.rejected, state => {
        state.licenses = null
      })

      .addCase(getCompanystatisticThunk.fulfilled, (state, action) => {
        state.companystatistic = action.payload
      })

      .addCase(getCompanystatisticThunk.rejected, state => {
        state.companystatistic = []
      })
  },
})

export const { actions, reducer } = authSlice
